<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Selecione a unidade que deseja acessar.')"
        centered
        @hidden="cancelar"
        id="modal-select_conta"
    >
        <load mode="table" v-if="loading" />
        <form v-else @submit.prevent="submit">
            <div class="row px-0">
                <form-radio
                    v-model="unidade_selected"
                    :itens="unidades_tecnico"
                />
            </div>
            <div class="row mt-3">
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-default" @click="cancelar">
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                    <button class="btn btn-success" type="submit">
                        <i class="mdi mdi-check-circle"></i> Acessar
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    name: "ModalSelecionarUnidade",
    data() {
        return {
            loading: true,
            tecnico: [],
            unidades: [],
            unidades_tecnico: [],
            unidade_selected: "",
            // load_change_unidade: this.$root.load_change_unidade
        };
    },

    mounted() {
        this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
            this.verificar();
        });
        this.verificar();
    },
    methods: {
        verificar() {
            let change = localStorage.getItem("changeUnidade");

            if (change == "false") {
                this.getUnidades();
            }
        },
        getUnidadesTecnico() {
            axios
                .get("api/dashboard/tecnico/get/unidades")
                .then((response) => {
                    this.tecnico = response.data.data;

                    //Só listar as Unidades com Status Ativo
                    this.tecnico.unidades = this.tecnico.unidades.filter(
                        (item) => item.status == 1
                    );

                    //Verifica se a unidade ativa é a mesma que ele está autenticado
                    // para não ser necessário exibir a modal
                    if (this.tecnico.unidades.length == 1) {
                        const minhaunidade = this.tecnico.unidades.filter(
                            (item) =>
                                item.id ==
                                this.$store.state.user.tecnico.unidade_id
                        );
                        if (minhaunidade.length > 0) {
                            return false;
                        }
                    }

                    if (this.tecnico.unidades.length > 1) {
                        this.setUnidadesTecnicos();
                        this.$bvModal.show("modal-select_conta");
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingSearchUnidade = false;
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;

                    this.getUnidadesTecnico();
                });
        },
        setUnidadesTecnicos() {
            this.unidades_tecnico = this.tecnico.unidades.map((elem) => ({
                id: elem.unidade_id,
                value: this.getNomeUnidade(elem.unidade_id),
            }));
        },
        getNomeUnidade(id) {
            const result = this.unidades.filter((item) => item.id == id);
            return result[0] ? result[0].value : "";
        },
        submit() {
            this.loading = true;
            axios
                .get(
                    `api/dashboard/tecnico/set/unidade/${this.unidade_selected}`
                )
                .then((response) => {
                    localStorage.setItem("changeUnidade", true);
                    location.reload();
                    this.cancelar();
                });
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$root.load_change_unidade = false;
            this.$bvModal.hide("modal-select_conta");
        },
    },
};
</script>
